import { Question } from "@sabyr-dev/mist_elibrary/datasource";
import { ElibraryListFrontend } from "@sabyr-dev/mist_elibrary/frontend";

export class AcademyListFrontend extends ElibraryListFrontend {
	displayLockedQuestions(freeQuestions: number, locked: boolean, baseColor: string): void {
		const itemList = Array.from(
			document.querySelectorAll<HTMLElement>('.item-list .item')
		);
		itemList.slice(freeQuestions).forEach(item => {
			item.style.background = locked ?
				'rgb(0, 50, 100, 0.5)' :
				baseColor;
		});
	}

	displayQuestionResult(item: Question, status: 'correct'|'incorrect'|'unanswered', time: number): void {
		const element = document.querySelector<HTMLElement>(
			`.item-list .item[data-id="${CSS.escape(this.itemIdSerializer.toString(item))}"]`
		);
		element.title = element.title.replace(/Time: \d+:\d+/, `Time: ${
			new Date(time).toLocaleTimeString(undefined, time > 60 * 60 * 1000 ? {
				hour: 'numeric', minute: '2-digit', second: '2-digit', timeZone: 'utc', hour12: false
			} : {
				minute: 'numeric', second: '2-digit', timeZone: 'utc', hour12: false
			})
		}`)
		const icon = element.querySelector<HTMLElement>('i.answer-status');
		icon.classList.remove('fas', 'fa-check', 'fa-times', 'd-none');
		if (status === 'correct') {
			icon.classList.add('fas', 'fa-check');
			element.style.backgroundColor = '#28a745';
			element.style.color = '#d4edda';
		} else if (status === 'incorrect') {
			icon.classList.add('fas', 'fa-times');
			element.style.backgroundColor = '#dc3545';
			element.style.color = '#f8d7da';
		} else if (status === 'unanswered') {
			icon.classList.add('d-none');
			element.style.backgroundColor = '#17a2b8';
			element.style.color = '#d1ecf1';
		}
	}
}